import { render, staticRenderFns } from "./producto_caracteristica.vue?vue&type=template&id=5c5f0502"
import script from "./producto_caracteristica.vue?vue&type=script&lang=js"
export * from "./producto_caracteristica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports